/** Turns a numeric-ish Haystack value into a number, or null when it is not one. */
export function extractNumber(val) {
  if (val == null) return null;
  if (typeof val === "number") return val;
  if (typeof val === "object" && val.val != null) return Number(val.val);
  if (typeof val === "string") {
    const m = val.match(/-?\d+(\.\d+)?/);
    return m ? Number(m[0]) : null;
  }
  return null;
}

/** Merges per-site history into one recharts dataset keyed by timestamp. */
export function mergeSiteSeries(sites) {
  if (!sites) return { chartData: [], siteKeys: [] };
  const byTs = new Map();
  const keys = [];
  for (const s of sites) {
    const key = s.site_dis || s.site_id;
    keys.push(key);
    for (const row of s.series || []) {
      const v = extractNumber(row.val);
      if (v == null || !row.ts) continue;
      const ts = new Date(row.ts).getTime();
      if (!byTs.has(ts)) byTs.set(ts, { ts });
      byTs.get(ts)[key] = v;
    }
  }
  return { chartData: Array.from(byTs.values()).sort((a, b) => a.ts - b.ts), siteKeys: keys };
}
